import { TabGroup, TabTitle, TabContent } from './components';

export default class Tab {

  static Group = TabGroup;

  static Title = TabTitle;

  static Content = TabContent;

  render() {}
}
